(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brador-oz"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.bradorOzInstalled) return;
    window.bradorOzInstalled = true;

    const excluded = 'script, style, textarea, select, option, code, pre, noscript, svg, math, [contenteditable]:not([contenteditable="false"]), .brador-weight-unit';
    const pending = new Set();
    let scheduled = false;

    function formatText(node) {
      const parent = node.parentElement;
      if (!parent || !node.isConnected || parent.closest(excluded)) return;
      const value = node.nodeValue;
      const matches = Array.from(value.matchAll(/\b(\d+(?:[.,]\d+)?\s*)oz\b/gi));
      if (!matches.length || !/bebas/i.test(getComputedStyle(parent).fontFamily)) return;

      const fragment = document.createDocumentFragment();
      let cursor = 0;

      for (const match of matches) {
        fragment.append(document.createTextNode(value.slice(cursor, match.index) + match[1]));
        const unit = document.createElement('span');
        unit.className = 'brador-weight-unit';
        unit.textContent = 'oz';
        fragment.append(unit);
        cursor = match.index + match[0].length;
      }

      fragment.append(document.createTextNode(value.slice(cursor)));
      node.replaceWith(fragment);
    }

    function scan(root) {
      if (!root.isConnected) return;
      if (root.nodeType === Node.TEXT_NODE) {
        formatText(root);
        return;
      }
      if (root.nodeType !== Node.ELEMENT_NODE || root.closest(excluded)) return;
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(formatText);
    }

    function queue(root) {
      if (root.nodeType === Node.TEXT_NODE || root.nodeType === Node.ELEMENT_NODE) pending.add(root);
      if (scheduled || !pending.size) return;
      scheduled = true;
      requestAnimationFrame(() => {
        const roots = Array.from(pending);
        pending.clear();
        scheduled = false;
        roots.forEach(scan);
      });
    }

    function start() {
      scan(document.body);
      const observer = new MutationObserver(records => {
        for (const record of records) {
          if (record.type === 'characterData') queue(record.target);
          else record.addedNodes.forEach(queue);
        }
      });
      observer.observe(document.body, { subtree: true, childList: true, characterData: true });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
